import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { formatDateSlash, getToken, setPodcastSession } from "../../utils";
import { getFullApiUrl, podcastId } from "../../config";
import { Button, Icon } from "../../designSystem";
import Notice from "../ui/Notice";
import { LoadingPage } from "../LoadingPage";

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [purchaseInfo, setPurchaseInfo] = useState(null);
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setError("缺少会话ID");
      setLoading(false);
      return;
    }

    // Check user's purchase status
    checkPurchaseStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const checkPurchaseStatus = async () => {
    try {
      const token = getToken();
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await axios.get(
        getFullApiUrl("/api/v1/stripe/user-purchases"),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.purchases && response.data.purchases.length > 0) {
        // Get the most recent purchase
        setPurchaseInfo(response.data.purchases[0]);

        // After confirming purchase, get user info including podcast session
        await fetchUserInfo();
      }
    } catch (err) {
      console.error("Failed to check purchase status:", err);
      setError("无法确认购买状态，请联系客服");
    } finally {
      setLoading(false);
    }
  };

  const fetchUserInfo = async () => {
    try {
      const token = getToken();
      if (!token) return;

      const response = await axios.get(
        getFullApiUrl(`/api/v1/auth/user-info?podcast_id=${podcastId}`),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.podcast_session) {
        setPodcastSession(response.data.podcast_session);
      }
    } catch (err) {
      console.error("Failed to fetch user info:", err);
      // Don't show error to user as this is optional
    }
  };

  const formatPrice = (amount, currency) => {
    const price = (amount / 100).toFixed(2);
    const currencySymbol = currency === "usd" ? "$" : "¥";
    return `${currencySymbol}${price}`;
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="lt-main">
      <div className="lt-result">
        <span className="lt-result__glyph lt-result__glyph--success">
          <Icon name="check_circle" fill style={{ verticalAlign: 0 }} />
        </span>
        <h1>购买成功</h1>
        <p className="desc">感谢您的购买，现在可以收听所有付费内容了。</p>

        {error ? (
          <Notice variant="warning" style={{ marginTop: 16, textAlign: "left" }}>
            {error}
          </Notice>
        ) : null}

        {purchaseInfo ? (
          <Notice variant="success" style={{ marginTop: 16, textAlign: "left" }}>
            金额 {formatPrice(purchaseInfo.amount, purchaseInfo.currency)} ·
            {purchaseInfo.status === "succeeded" ? "支付成功" : purchaseInfo.status} ·
            {formatDateSlash(purchaseInfo.purchased_at)}
          </Notice>
        ) : null}

        <Notice variant="info" style={{ marginTop: 12, textAlign: "left" }}>
          加入付费用户群：添加微信号 anotherlambda 并附上注册邮箱，anotherlambda
          会邀请你进群。
        </Notice>

        <div className="actions">
          <Button size="lg" icon="play_arrow" onClick={() => navigate("/")}>
            开始收听
          </Button>
        </div>

        <p className="foot">如有任何问题，请联系客服微信：anotherlambda</p>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
